
export default {
  mobile: {
    name: 'mobile',
    size: 0,
    index: 0,
  },
  tablet: {
    name: 'tablet',
    size: 1024,
    index: 10,
  },
  desktop: {
    name: 'desktop',
    size: 1366,
    index: 50,
  },
  hd: {
    name: 'hd',
    size: 1921,
    index: 60,
  },
};



// WEBPACK FOOTER //
// ./src/lib/breakpoints.js